import { Field } from 'redux-form';
import ColorPickerTile from '../../ColorPickerTile/colorPickerTile';

const ColorPickerTileField = (props) => {
  return <Field {...props} component={ColorPickerTile}></Field>;
};

export default ColorPickerTileField;
